import { Route } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";

import { Collection } from "./Collection";
import { Collections } from "./ViewCollections";

export const CollectionsRoutes = () => [
  <Route
    key="/"
    index
    loader={loadSearchTablePreferences(
      queryClient,
      "collection_search_table_preferences",
    )}
    element={<Collections />}
  />,
  <Route key=":collectionId" path=":collectionId" element={<Collection />} />,
];
